<div class="container">
  <h2>Upload de Nota de Corretagem</h2>
  <div class="upload">
    <input type="file" (change)="onFileSelected($event)" accept="application/pdf">
    <button mat-raised-button (click)="processPDF()" [disabled]="isLoading || isGenerating">Processar PDF</button>
  </div>

  <div *ngIf="isLoading">Carregando...</div>
  <p *ngIf="errorMessage" class="error">{{ errorMessage }}</p>

  <section *ngIf="preview">
    <h3>Nota {{ preview.noteNumber || 'N/A' }} — Pregão {{ preview.date || 'N/A' }}</h3>
    <div class="summary">
      <span>Valor das operações: R$ {{ preview.totalOperations | number:'1.2-2' }}</span>
      <span>Taxa de liquidação: R$ {{ preview.liquidationTax | number:'1.2-2' }}</span>
      <span>Taxa de registro: R$ {{ preview.registrationTax | number:'1.2-2' }}</span>
      <span>Emolumentos: R$ {{ preview.emoluments | number:'1.2-2' }}</span>
      <span>Taxa de transferência: R$ {{ preview.transferTax | number:'1.2-2' }}</span>
      <span>Corretagem (clearing): R$ {{ preview.clearing | number:'1.2-2' }}</span>
      <span>ISS: R$ {{ preview.iss | number:'1.2-2' }}</span>
      <span>ISS/PIS/COFINS: R$ {{ preview.issPisCofins | number:'1.2-2' }}</span>
      <span>Total corretagem / despesas: R$ {{ preview.totalExpenses | number:'1.2-2' }}</span>
      <span>Líquido para {{ preview.settlementDate || 'N/A' }}: R$ {{ preview.netValue | number:'1.2-2' }} {{ preview.netDebitCredit }}</span>
    </div>
  </section>

  <section *ngIf="draft && context" class="import">
    <h3>Papéis</h3>

    <div class="asset" *ngFor="let asset of draft.assets">
      <div class="asset-title">
        <strong>{{ asset.title }}</strong>
        <span class="tag ok" *ngIf="asset.matchedShare">papel encontrado</span>
        <span class="tag new" *ngIf="asset.shareCode == NEW_RECORD">papel novo</span>
      </div>

      <mat-form-field>
        <mat-label>Papel</mat-label>
        <mat-select [(ngModel)]="asset.shareCode" (selectionChange)="onShareSelected(asset)" [ngModelOptions]="{ standalone: true }">
          <mat-option [value]="NEW_RECORD">+ Novo papel</mat-option>
          <mat-option *ngFor="let s of context.shares" [value]="s.code">{{ s.code }} — {{ s.alias }} ({{ s.type }})</mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="asset.shareCode == NEW_RECORD">
        <div class="row">
          <mat-form-field>
            <mat-label>Código (ticker)</mat-label>
            <input matInput [ngModel]="asset.newShare.code" (ngModelChange)="onNewShareCode(asset, $event)" [ngModelOptions]="{ standalone: true }" placeholder="EZTC3">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Alias</mat-label>
            <input matInput [(ngModel)]="asset.newShare.alias" [ngModelOptions]="{ standalone: true }">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Tipo</mat-label>
            <mat-select [(ngModel)]="asset.type" (selectionChange)="onTypeChanged()" [ngModelOptions]="{ standalone: true }">
              <mat-option value="STOCK">Stock</mat-option>
              <mat-option value="REIT">Reit</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-checkbox [(ngModel)]="asset.newShare.dividends" [ngModelOptions]="{ standalone: true }">Pays dividends</mat-checkbox>
        </div>

        <div class="row">
          <mat-form-field>
            <mat-label>Empresa</mat-label>
            <mat-select [(ngModel)]="asset.companyCode" [ngModelOptions]="{ standalone: true }">
              <mat-option [value]="NEW_RECORD">+ Nova empresa</mat-option>
              <mat-option *ngFor="let c of context.companies" [value]="c.code">{{ c.name }} ({{ c.code }})</mat-option>
            </mat-select>
            <mat-hint *ngIf="asset.matchedCompany">empresa encontrada</mat-hint>
          </mat-form-field>
          <ng-container *ngIf="asset.companyCode == NEW_RECORD">
            <mat-form-field>
              <mat-label>Nome da empresa</mat-label>
              <input matInput [(ngModel)]="asset.newCompany.name" [ngModelOptions]="{ standalone: true }">
            </mat-form-field>
            <mat-form-field>
              <mat-label>Código da empresa</mat-label>
              <input matInput [ngModel]="asset.newCompany.code" (ngModelChange)="asset.newCompany.code = $event.toUpperCase()" [ngModelOptions]="{ standalone: true }" placeholder="EZTC">
            </mat-form-field>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <h3>Negócios</h3>
    <div class="table-wrapper">
      <table>
        <thead><tr><th>C/V</th><th>Papel</th><th>Destino</th><th>Quantidade</th><th>Preço</th><th>Valor</th><th>Taxas</th><th>Total</th></tr></thead>
        <tbody>
          <tr *ngFor="let item of draft.trades">
            <td>{{ item.trade.side === 'C' ? 'Compra' : 'Venda' }}</td>
            <td>{{ item.asset.shareCode == NEW_RECORD ? (item.asset.newShare.code || item.asset.title) : item.asset.shareCode }}</td>
            <td>{{ item.asset.type == 'REIT' ? 'Reits' : 'Stocks' }}</td>
            <td>{{ item.trade.quantity }}</td>
            <td>R$ {{ item.trade.price | number:'1.2-2' }}</td>
            <td>R$ {{ item.trade.total | number:'1.2-2' }}</td>
            <td>
              <input *ngIf="item.asset.type != 'REIT'" class="tax" type="number" step="0.01" min="0" [(ngModel)]="item.tax" [ngModelOptions]="{ standalone: true }">
              <span *ngIf="item.asset.type == 'REIT'">—</span>
            </td>
            <td>R$ {{ item.trade.total + (item.tax || 0) | number:'1.2-2' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="note">As taxas da nota foram rateadas proporcionalmente ao valor de cada negócio. Reits não levam taxa.</p>

    <div *ngIf="draft.alreadyImported" class="warning">
      <p>Esta nota já tem {{ draft.alreadyImported }} lançamento(s) importado(s).</p>
      <mat-checkbox [(ngModel)]="confirmDuplicate" [ngModelOptions]="{ standalone: true }">Importar mesmo assim</mat-checkbox>
    </div>

    <ul *ngIf="validationErrors.length" class="error">
      <li *ngFor="let e of validationErrors">{{ e }}</li>
    </ul>

    <button mat-raised-button color="primary" (click)="generate()" [disabled]="!canGenerate">
      {{ isGenerating ? 'Gerando...' : 'Gerar lançamentos' }}
    </button>

    <p *ngIf="result" class="success">
      Criado: {{ result.companies }} empresa(s), {{ result.shares }} papel(is), {{ result.stocks }} lançamento(s) em Stocks e {{ result.reits }} em Reits.
    </p>
  </section>

  <details *ngIf="extractedText">
    <summary>Texto extraído</summary>
    <pre>{{ extractedText }}</pre>
  </details>
</div>
